import { render, staticRenderFns } from "./authGuide.vue?vue&type=template&id=3680b828&scoped=true"
import script from "./authGuide.vue?vue&type=script&lang=js"
export * from "./authGuide.vue?vue&type=script&lang=js"
import style0 from "./authGuide.vue?vue&type=style&index=0&id=3680b828&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680b828",
  null
  
)

export default component.exports